import { SoundManagementRepository } from '../data/sound-management-repository';
import { DeleteMediaResponse } from '../types/sound-management-types';

/**
 * Delete Sound Use Case
 * Handles deleting a sound file
 */
export class DeleteSoundUseCase {
  constructor(private readonly repository: SoundManagementRepository) {}

  async execute(mediaId: number): Promise<DeleteMediaResponse> {
    return this.repository.deleteSound(mediaId);
  }
}
